export default "__VITE_ASSET__DSc2XBlj__"